import { ITextValue } from '@/types/common';
import { Nullable } from '@/utils/types';
import { IComparable, TransactionTypeEnum } from '@/bundles/Comparables/types';
import { isValuePresent } from '@/bundles/App/helpers/isValuePresent';

export * from './comparablesHeadersData';
export * from './mapHelpers';
export * from './generateMapFeaturesFromComparableList';

export enum RentTypeEnum {
  per_month = 'Months',
  per_year = 'Years'
}

export const RentTypeLabels = {
  [RentTypeEnum.per_month]: 'Per Month',
  [RentTypeEnum.per_year]: 'Per Year'
}

export const getRentTypeItems = (): ITextValue<string>[] => {
  return Object.keys(RentTypeLabels).map(key => {
    return {
      text: RentTypeLabels[key],
      value: key
    }
  })
};

export const getComparableLeaseTermLength = (comparable: IComparable): Nullable<string> => {
  if (!comparable?.transaction?.lease_term_length) {
    return null;
  }
  const leaseTerm = `${comparable.transaction.lease_term_length} Months`;

  if (comparable.rent_schedule?.periods?.length) {
    const calculatedTerm = {
      days: 0,
      months: 0
    };

    comparable.rent_schedule.periods.reduce((acc, item) => {
      acc[item.period_type] += item.periods;

      return acc;
    }, calculatedTerm);

    return `${calculatedTerm.months ? `${calculatedTerm.months} Months` : ''} ${calculatedTerm.days ? `${calculatedTerm.days} Days` : ''}`.trim();
  }

  return leaseTerm;
};

export const getComparableFreeRentLength = (comparable: IComparable): Nullable<string> => {
  if (comparable?.transaction?.transaction_type !== TransactionTypeEnum.lease || !isValuePresent(comparable?.transaction?.free_rent)) {
    return null;
  }

  if (!comparable.rent_schedule?.periods?.length) {
    return `${comparable.transaction.free_rent} Months`;
  }

  const calculatedFreeRent = {
    days: 0,
    months: 0
  };

  comparable.rent_schedule.periods.filter(item => !item.total).reduce((acc, item) => {
    acc[item.period_type] += item.periods;

    return acc;
  }, calculatedFreeRent);

  return `${calculatedFreeRent.months ? `${calculatedFreeRent.months} Months` : ''} ${calculatedFreeRent.days ? `${calculatedFreeRent.days} Days` : ''}`.trim();
};
